import api from './api';
import { type GADMZone } from './gadmService';

export interface Commerce {
  comercio_key: string;
  nombre: string;
  gadm_zone_id?: string;
  gadm_zone_name?: string;
  // Use a broad type to avoid external geojson typings
  gadm_zone_geometry?: any;
  // Add other commerce properties as needed
}

export const commerceService = {
  getCommerceByKey: async (comercioKey: string): Promise<Commerce> => {
    try {
      const response = await api.get(`/comercios/${comercioKey}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching commerce by key:', error);
      throw error;
    }
  },

  updateCommerceGadmZone: async (comercioKey: string, gadmZone: GADMZone | null): Promise<Commerce> => {
    try {
      const payload = {
        gadm_zone_id: gadmZone ? gadmZone.id : null,
        gadm_zone_name: gadmZone ? gadmZone.name : null,
        gadm_zone_geometry: gadmZone ? gadmZone.geometry : null,
      };
      const response = await api.put(`/comercios/${comercioKey}/gadm-zone`, payload);
      return response.data;
    } catch (error) {
      console.error('Error updating commerce GADM zone:', error);
      throw error;
    }
  },
};